import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { abbreviateNumber, freeBetStore } from '@pascal/pascal-core';
import { defineChipColor } from '../../helpers/chipColor';
import { doBetStore } from '../../store/doBetStore';

export const ChipSection = observer(({ handleDoChip = null, betType, position = '' }) => {
  const { lastBetModel, quickBets } = doBetStore;
  const { activeFreeBet } = freeBetStore;

  const memoAmountByBetType = useMemo(() => {
    if (lastBetModel?.betModel?.length) {
      const bet = lastBetModel.betModel.find((item) => item.type === betType);
      if (bet) {
        return bet.hasOwnProperty('winAmount') ? bet.winAmount : bet.amount;
      }
    }
    return 0;
  }, [lastBetModel, betType]);

  return (
    <div
      className={`football-field-roof-chip ${position} ${defineChipColor(
        memoAmountByBetType,
        quickBets
      )} ${abbreviateNumber(memoAmountByBetType).toString().length > 3 ? 'large' : ''} ${
        !!memoAmountByBetType && activeFreeBet.id ? 'free-chip' : ''
      } `}
      onClick={() => handleDoChip && handleDoChip(betType)}
    >
      <span className='football-field-roof-chip-number'>
        {abbreviateNumber(memoAmountByBetType) || null}
      </span>
    </div>
  );
});
